@if (languageCode$ | async) {
  <h3 class="card-title">{{ 'proposal.context.additional-info' | translate }}</h3>
  <div class="wrapper">
    <div class="property" *ngIf="languageCode$ | async">
      <div class="title">{{ 'agreement.language-version' | translate }}</div>
      <span class="status">{{
        'languageCode.' + (languageCode$ | async) + '.label' | translate
      }}</span>
    </div>
    @if (agreement) {
      <ax-agreement-subscriber [agreement]="agreement"> </ax-agreement-subscriber>
    }

    <div
      class="code property"
      *ngIf="agreement?.agreementCode && (owner$ | async)?.id === agreement?.proposalOwnerId"
    >
      <div class="title">{{ 'agreement.confirm-link' | translate }}</div>
      <div class="code-wrapper">
        <ax-copy-text
          [value]="baseUrl + '/proposal/agreement/confirm/' + agreement?.agreementCode"
        ></ax-copy-text>
        <button
          class="email-button"
          *ngIf="!agreement?.agreementData?.confirmed && (isOwner$ | async)"
          axButton
          color="primary"
          filled
          (click)="didClickSendEmail.next($event)"
        >
          <ax-icon class="icon" [name]="iconNameForCommunicationType(communicationType)"></ax-icon>
          {{ 'label.sendByEmail' | translate }}
        </button>
      </div>
    </div>
  </div>
}
